// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as LocationInfoActionCmpModuleScss from "../styles/LocationInfoActionCmp.module.scss";

var styles = LocationInfoActionCmpModuleScss;

function ChangeLocationActionCmp(Props) {
  var open_select_location = Props.open_select_location;
  var city = Props.city;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles.city
                }, Belt_Option.getWithDefault(city, "")), React.createElement("button", {
                  className: styles["action-change"],
                  onClick: (function (param) {
                      Curry._1(open_select_location, undefined);
                    })
                }, "Change"));
}

var make = ChangeLocationActionCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
